/* global Stimulus */

const RENDER_ROOT_MARGIN = "400px 0px"

stimulusApp.register(
  "photo-prefetch",
  class extends Stimulus.Controller {
    #observer = null

    connect() {
      // Decode and paint the card ahead of the viewport so `content-visibility`'s
      // deferred render is ready before the card scrolls into view, instead of
      // pulsing the placeholder while the browser renders it at the edge.
      // https://github.com/halalbooking/halalbooking/pull/29383
      this.#observer = new IntersectionObserver(
        (entries) => {
          if (!entries[entries.length - 1].isIntersecting) return
          this.#observer.disconnect()
          this.element.style.contentVisibility = "visible"
        },
        { rootMargin: RENDER_ROOT_MARGIN },
      )
      this.#observer.observe(this.element)
    }

    disconnect() {
      this.#observer?.disconnect()
    }
  },
)
